function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
export function isJSONArray(value) {
  return Array.isArray(value);
}
export function isJSONObject(value) {
  return value !== null && _typeof(value) === 'object' && value.constructor === Object // do not match on classes or Array
  ;
}

export function isJSONPatchOperation(value) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return value && _typeof(value) === 'object' ? typeof value.op === 'string' : false;
}
export function isJSONPatchAdd(value) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return value && _typeof(value) === 'object' ? value.op === 'add' : false;
}
export function isJSONPatchRemove(value) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return value && _typeof(value) === 'object' ? value.op === 'remove' : false;
}
export function isJSONPatchReplace(value) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return value && _typeof(value) === 'object' ? value.op === 'replace' : false;
}
export function isJSONPatchCopy(value) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return value && _typeof(value) === 'object' ? value.op === 'copy' : false;
}
export function isJSONPatchMove(value) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return value && _typeof(value) === 'object' ? value.op === 'move' : false;
}
export function isJSONPatchTest(value) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return value && _typeof(value) === 'object' ? value.op === 'test' : false;
}
//# sourceMappingURL=typeguards.js.map